import axios from 'axios';

import { type Common } from '../common.js';
import { type Document, type FindAllOptions } from '../models/document/index.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<Document[]> {
    const url = this.common.constructPath(`/documents`, options);
    return await this.common.getJSON(url);
  }

  downloadURL(id: string): string {
    return this.common.constructPath(`/documents/${id}/file`);
  }

  async getUploadUrl(
    fileName: string,
    extension: string
  ): Promise<{ url: string; gsPath: string; bucketName: string }> {
    const url = this.common.constructPath(`/documents/upload-url`, {
      fileName,
      extension,
    });
    return await this.common.getJSON(url);
  }

  async upload(args: { file: File; url: string; contentType: string }): Promise<number> {
    const { file, url, contentType } = args;
    const res = await axios.put(url, file, {
      headers: { 'Content-Type': contentType },
    });
    return res.status;
  }
}
